import { updateAnalyticsConsent } from './utils/analytics.js';

class CookieConsent extends HTMLElement {
    constructor() {
        super();
        this.consentUrl = this.getAttribute('consent-url') || '/';
    }

    
    connectedCallback() {
        // Only proceed if we're on the homepage
        if (window.location.pathname === '/' || window.location.pathname === '/index.html') {
            this.render();
            this.initializeCookieConsent();
        }
    }


    render() {
        // CSS is now loaded in the head, no need to load it here
    }

    initializeCookieConsent() {
        // Idle island already deferred this; do not compete with LCP via preload/high priority.
        const script = document.createElement('script');
        script.src = '/assets/vendor/cookieconsent.min.js';
        script.fetchPriority = 'low';
        script.onload = () => {
            this.setupCookieConsent();
        };
        script.onerror = () => {
            // Fallback to CDN if self-hosted version fails
            console.warn('Self-hosted cookie consent script failed, falling back to CDN');
            const fallbackScript = document.createElement('script');
            fallbackScript.src = 'https://cdn.jsdelivr.net/npm/cookieconsent@3/build/cookieconsent.min.js';
            fallbackScript.crossOrigin = 'anonymous';
            fallbackScript.onload = () => {
                this.setupCookieConsent();
            };
            document.head.appendChild(fallbackScript);
        };
        document.head.appendChild(script);
    }

    setupCookieConsent() {
        window.cookieconsent.initialise({
            autoOpen: true,
            theme: "classic",
            position: "bottom-right",
            type: "opt-out",
            content: {
                message: 'This website uses cookies to improve your experience.',
                dismiss: 'Got it!',
                deny: 'Decline',
                link: 'Learn more',
                href: '/privacy-policy/',
                close: '&#x274c;',
                policy: '🍪',
                target: '_self'
            },
            elements: {
                allow: '<button aria-label="Allow Cookies" tabindex="0" class="cc-btn cc-allow tt-main-menu-list">Accept</button>',
            },
            revokable: true,
            layout: 'basic',
            onInitialise: (status) => {
                // Add active class to make visible after initialization
                this.makeVisible();
                this.handleStatusChange(status);
            },
            onStatusChange: (status) => {
                this.handleStatusChange(status);
            },
            onRevokeChoice: () => {
                this.handleRevokeChoice();
            }
        });
        
        // Also check immediately in case window is created synchronously
        this.makeVisible();
    }

    makeVisible() {
        // Check for existing windows immediately
        const windows = document.querySelectorAll('.cc-window');
        if (windows.length > 0) {
            windows.forEach(window => {
                window.classList.add('cc-active');
            });
        } else {
            // If no windows found yet, check again after a short delay
            // This handles cases where the library creates the window asynchronously
            setTimeout(() => {
                const delayedWindows = document.querySelectorAll('.cc-window');
                delayedWindows.forEach(window => {
                    window.classList.add('cc-active');
                });
            }, 100);
        }
    }

    handleStatusChange(status) {
        if (status === 'allow') {
            this.enableCookies();
        } else {
            this.disableCookies();
        }
    }

    handleRevokeChoice() {
        // this.disableCookies();
    }

    enableCookies() {
        localStorage.setItem('cookies', 'enabled');
        updateAnalyticsConsent(true);
    }

    disableCookies() {
        localStorage.setItem('cookies', 'disabled');
        updateAnalyticsConsent(false);
    }
}

customElements.define('cookie-consent', CookieConsent);